export default __webpack_public_path__ + "static/media/dorcas.29f290c7.jpg";